export default "__VITE_ASSET__239ddb9c__"